import { DietData } from 'modules/users/models/User'

export const DIET_TYPES = [
  'dietBasal',
  'dietHyposodic',
  'dietHyperproteic',
  'dietDiabetic',
] as const

export const DIET_TEXTURES = ['textureEasyChewing', 'texturePureed', 'textureNormal'] as const

export type DietType = (typeof DIET_TYPES)[number]
export type DietTexture = (typeof DIET_TEXTURES)[number]

export function formatDietRaw(diet: DietData | undefined): {
  types: string[]
  texture: string | null
  isEmpty: boolean
} {
  if (!diet || diet.types.length === 0) {
    return { types: [], texture: null, isEmpty: true }
  }
  return {
    types: diet.types,
    texture: diet.texture || null,
    isEmpty: false,
  }
}

export function formatDietStringRaw(diet: DietData | undefined): string {
  if (!diet || diet.types.length === 0) return 'basalDiet'
  const types = diet.types.join(', ')
  const texture = diet.texture ? ` - ${diet.texture}` : ''
  return `${types}${texture}`
}
